export { IxPricing } from './IxPricing.js';
